import React, { useState } from "react";
import ProgressProvider from "./ProgressProvider";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import { useTranslation } from "react-i18next";
import { AiOutlineInfoCircle } from "react-icons/ai";
import styles from "./CreditScore.module.css";

export default function CreditScoreCircularBar({ valueEnd, showModal }) {
  const { t } = useTranslation();

  return (
    <>
      <div
        style={{
          //   border: "1px solid red",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            // border: "1px solid green",
            marginBottom: "-20px",
          }}
        >
          <ProgressProvider valueStart={0} valueEnd={valueEnd}>
            {(value) => (
              <CircularProgressbarWithChildren
                minValue={300}
                maxValue={900}
                value={value}
                strokeWidth={6}
                circleRatio={0.75}
                // valueStart={50}
                styles={{
                  path: {
                    transform: "rotate(223deg)",
                    transformOrigin: "center center",
                    transition: "stroke-dashoffset 0.9s ease 0s",
                    strokeLinecap: "round",
                    stroke:
                      valueEnd > 779
                        ? "#00CC66"
                        : valueEnd > 699
                        ? "#90EE90"
                        : valueEnd > 599
                        ? "#F6BE00"
                        : "red",
                  },
                  trail: {
                    transform: "rotate(223deg)",
                    transformOrigin: "center center",
                    stroke: "#E5E5E5",
                    strokeLinecap: "round",
                  },
                  root: {
                    width: "160px",
                  },
                }}
              >
                <div
                  style={{
                    // border:"1px solid red",
                    marginTop: "-60px",
                  }}
                >
                  <p
                    style={{
                      color:
                        valueEnd > 779
                          ? "#00CC66"
                          : valueEnd > 699
                          ? "#90EE90"
                          : valueEnd > 599
                          ? "#F6BE00"
                          : "red",
                      fontSize: "30px",
                      fontWeight: 700,
                    }}
                  >
                    {value}
                  </p>
                  <div
                    style={{
                      marginTop: "-35px",
                      fontSize: "15px",
                      fontWeight: 600,
                      // marginLeft: "-10px",
                    }}
                  >
                    <span
                      style={{
                        color:
                          valueEnd > 779
                            ? "#00CC66"
                            : valueEnd > 699
                            ? "#90EE90"
                            : valueEnd > 599
                            ? "#F6BE00"
                            : "red",
                      }}
                    >
                      {valueEnd > 779
                        ? t("creditScore.excellent")
                        : valueEnd > 699
                        ? t("creditScore.good")
                        : valueEnd > 599
                        ? t("creditScore.average")
                        : t("creditScore.poor")}
                    </span>
                    <AiOutlineInfoCircle
                      style={{
                        color: "#6C63FF",
                        marginLeft: "5px",
                        marginBottom: "-3px",
                      }}
                      onClick={showModal}
                    />
                  </div>
                </div>
              </CircularProgressbarWithChildren>
            )}
          </ProgressProvider>
        </div>
      </div>
      <div className={styles.barDetails}>
        <div
          style={{
            marginLeft: "15px",
            marginRight: "70px",
          }}
        >
          <p
            style={{
              fontSize: "16px",
              fontWeight: 500,
              marginBottom: "0px",
            }}
          >
            300
          </p>
          <p
            style={{
              fontSize: "12px",
            }}
          >
            {t("creditScore.poor")}
          </p>
        </div>
        <div>
          <p
            style={{
              fontSize: "16px",
              fontWeight: 500,
              marginBottom: "0px",
            }}
          >
            900
          </p>
          <p
            style={{
              fontSize: "12px",
            }}
          >
            {t("creditScore.excellent")}
          </p>
        </div>
      </div>
    </>
  );
}
